import PrivacyPolicyPopup from './PrivacyPolicyPopup';

export default PrivacyPolicyPopup;
